module.exports = __webpack_public_path__ + "img/provider9.1a00ee9d.png";